import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class GrowOnboardingGuardService {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(fromAppRoot.selectCustomerAndGrowAccount),
      map(({ customer, growAccount }) => {
        const noExistingGrowAccount = customer.temporary_accounts.findIndex((account) => account.kind === 'grow') < 0;

        if (noExistingGrowAccount) {
          return true;
        }

        if (customer.inyova_pro) {
          return this.router.parseUrl('/');
        }

        const stepStatus = growAccount?.step_status;

        if (stepStatus !== undefined && stepStatus <= 1) {
          return true;
        }

        if (stepStatus !== undefined && stepStatus <= 3) {
          return this.router.parseUrl('/next/saxo-account');
        }

        return this.router.parseUrl('/grow');
      })
    );
  }
}

export const GrowOnboardingGuard: CanActivateFn = () => {
  return inject(GrowOnboardingGuardService).canActivate();
};
